import noUiSlider from "nouislider";
import { trans } from "../../functions";
import { collapseFilters } from "./index/helpers";

export default {
    props: [
        "initialQuery",
        "initialBrandName",
        "initialBrandBanner",
        "initialBrandSlug",
        "initialCategoryName",
        "initialCategoryBanner",
        "initialCategorySlug",
        "initialCategoryDescriptionTop",
        "initialCategoryDescriptionBottom",
        "initialTagName",
        "initialTagSlug",
        "initialAttribute",
        "maxPrice",
        "maxWidth",
        "maxHeight",
        "maxDepth",
        "initialSort",
        "initialPerPage",
        "initialPage",
        "initialViewMode"
    ],

    data() {
        return {
            fetchingProducts: false,
            products: { data: [] },
            attributeFilters: [],
            brandBanner: this.initialBrandBanner,
            categoryName: this.initialCategoryName,
            categoryBanner: this.initialCategoryBanner,
            categoryDescriptionTop : this.initialCategoryDescriptionTop,
            categoryDescriptionBottom : this.initialCategoryDescriptionBottom,
            viewMode: this.initialViewMode,
            queryParams: {
                query: this.initialQuery,
                brand: this.initialBrandSlug,
                category: this.initialCategorySlug,
                tag: this.initialTagSlug,
                attribute: this.initialAttribute,
                fromPrice: 0,
                toPrice: this.maxPrice,
                fromWidth: 0,
                toWidth: this.maxWidth,
                fromHeight: 0,
                toHeight: this.maxHeight,
                fromDepth: 0,
                toDepth: this.maxDepth,
                sort: this.initialSort,
                perPage: this.initialPerPage,
                page: this.initialPage
            }
        };
    },

    computed: {
        emptyProducts() {
            return this.products.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.products.total / this.queryParams.perPage);
        },

        showingResults() {
            if (this.emptyProducts) {
                return;
            }

            return trans("product::products.showing_results", {
                from: this.products.from,
                to: this.products.to,
                total: this.products.total
            });
        }
    },

    watch: {
        // queryParams(queryParams){
        //     if(localStorage.queryParams){
        //
        //     }else if (queryParams.page > 1) {
        //
        //     }
        //     console.log(queryParams.category);
        // }
    },


    mounted() {
        this.addEventListeners();
        this.initPriceFilter();

        if(localStorage.queryParams){
          let getParams = JSON.parse(localStorage.queryParams);
          if (this.queryParams.query == getParams.query && this.queryParams.category == getParams.category && this.queryParams.brand == getParams.brand ) {
            this.queryParams = JSON.parse(localStorage.queryParams);
          }
        }

        if (this.$refs.widthRange) {
          this.initWidthFilter();
        }

        if (this.$refs.heightRange) {
          this.initHeightFilter();
        }

        if (this.$refs.depthRange) {
          this.initDepthFilter();
        }


        this.fetchProducts();
    },

    methods: {
        addEventListeners() {
            $(this.$refs.sortSelect).on("change", e => {
                this.queryParams.sort = e.currentTarget.value;

                this.fetchProducts();
            });

            $(this.$refs.perPageSelect).on("change", e => {
                this.queryParams.perPage = e.currentTarget.value;

                this.fetchProducts();
            });


        },

        initDepthFilter() {
            noUiSlider.create(this.$refs.depthRange, {
                connect: true,
                direction: window.Shop.rtl ? "rtl" : "ltr",
                start: [0, this.maxDepth],
                range: {
                    min: [0],
                    max: [this.maxDepth]
                }
            });

            this.$refs.depthRange.noUiSlider.on("update", (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromDepth = value;
                } else {
                    this.queryParams.toDepth = value;
                }
            });

            this.$refs.depthRange.noUiSlider.on("change", this.fetchProducts);
        },

        updateDepthRange(fromDepth, toDepth) {
            this.$refs.depthRange.noUiSlider.set([fromDepth, toDepth]);

            this.fetchProducts();
        },

        initHeightFilter() {
            noUiSlider.create(this.$refs.heightRange, {
                connect: true,
                direction: window.Shop.rtl ? "rtl" : "ltr",
                start: [0, this.maxHeight],
                range: {
                    min: [0],
                    max: [this.maxHeight]
                }
            });

            this.$refs.heightRange.noUiSlider.on("update", (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromHeight = value;
                } else {
                    this.queryParams.toHeight = value;
                }
            });

            this.$refs.heightRange.noUiSlider.on("change", this.fetchProducts);
        },

        updateHeightRange(fromHeight, toHeight) {
            this.$refs.heightRange.noUiSlider.set([fromHeight, toHeight]);

            this.fetchProducts();
        },

        initWidthFilter() {
            noUiSlider.create(this.$refs.widthRange, {
                connect: true,
                direction: window.Shop.rtl ? "rtl" : "ltr",
                start: [0, this.maxWidth],
                range: {
                    min: [0],
                    max: [this.maxWidth]
                }
            });

            this.$refs.widthRange.noUiSlider.on("update", (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromWidth = value;
                } else {
                    this.queryParams.toWidth = value;
                }
            });

            this.$refs.widthRange.noUiSlider.on("change", this.fetchProducts);
        },

        updateWidthRange(fromWidth, toWidth) {
            this.$refs.widthRange.noUiSlider.set([fromWidth, toWidth]);

            this.fetchProducts();
        },


        initPriceFilter() {
            noUiSlider.create(this.$refs.priceRange, {
                connect: true,
                direction: window.Shop.rtl ? "rtl" : "ltr",
                start: [0, this.maxPrice],
                range: {
                    min: [0],
                    max: [this.maxPrice]
                }
            });

            this.$refs.priceRange.noUiSlider.on("update", (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromPrice = value;
                } else {
                    this.queryParams.toPrice = value;
                }
            });

            this.$refs.priceRange.noUiSlider.on("change", this.fetchProducts);
        },

        updatePriceRange(fromPrice, toPrice) {
            this.$refs.priceRange.noUiSlider.set([fromPrice, toPrice]);

            this.fetchProducts();
        },

        toggleAttributeFilter(slug, value) {
            if (!this.queryParams.attribute.hasOwnProperty(slug)) {
                this.queryParams.attribute[slug] = [];
            }

            if (this.queryParams.attribute[slug].includes(value)) {
                this.queryParams.attribute[slug].splice(
                    this.queryParams.attribute[slug].indexOf(value),
                    1
                );
            } else {
                this.queryParams.attribute[slug].push(value);
            }

            this.fetchProducts({ updateAttributeFilters: false });
        },

        isFilteredByAttribute(slug, value) {
            if (!this.queryParams.attribute.hasOwnProperty(slug)) {
                return false;
            }

            return this.queryParams.attribute[slug].includes(value);
        },

        changeCategory(category) {
            this.categoryName = category.name;
            this.categoryDescriptionBottom = category.description_bottom;
            this.categoryDescriptionTop = category.description;
            this.queryParams.query = null;
            this.queryParams.category = category.slug;
            this.queryParams.attribute = {};
            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changePage(page) {
            this.queryParams.page = page;

            this.fetchProducts();
        },

        fetchProducts(options = { updateAttributeFilters: true }) {
            this.fetchingProducts = true;

            $.ajax({
                url: route("products.index", this.queryParams)
            })
                .then(response => {
                    this.products = response.products;
                    localStorage.queryParams = JSON.stringify(this.queryParams);

                    if (options.updateAttributeFilters) {
                        this.attributeFilters = response.attributes;
                    }

                    this.$nextTick(() => {
                        collapseFilters();
                    });
                })
                .catch(xhr => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.fetchingProducts = false;
                });
        }
    }
};
